import * as React from 'react';

// eslint-disable-next-line react/jsx-no-useless-fragment
export const InnerPageLayoutBottom: React.FC<React.PropsWithChildren> = ({ children }) => <>{children}</>;
